<template>
	<GenericIFrame :dashboardId="this.$store.getters.getCurrentDashboardId"/>
</template>

<script>


import GenericIFrame from '@/components/GenericIFrame';

export default {
	components: {
		GenericIFrame
	}
};

</script>

